import { Box } from '@ethings/ui-toolkit';
import L from 'leaflet';
import { FC, useRef } from 'react';
import { Tooltip, TooltipProps } from 'react-leaflet';
import { Nullable } from '../../../../types';
import { EventBreadcrumbPopover } from '../../thing-event-pane/event-breadcrumb-popover';
import { EventLocationData } from '../../thing-event-pane/thing-event-pane.types';
import { ClusterSummary } from './cluster-summary';
import './cluster.styles.css';

interface Props extends TooltipProps {
  expanded?: boolean;
  summaryData: EventLocationData[];
  eventData: EventLocationData[];
  eventId?: Nullable<string>;
  type: 'summary' | 'event';
}

export const ClusterTooltip: FC<Props> = ({
  direction,
  eventHandlers,
  expanded = false,
  summaryData,
  eventData,
  eventId,
  position,
  type,
  ...props
}) => {
  const ref = useRef<L.Tooltip>(null);

  const tooltipType = `${type}-tooltip`;
  let selectedData = summaryData;

  if (type === 'event') {
    selectedData = eventData.filter((event) => event.eventId === eventId);
  }

  const handleDataLoaded = (): void => {
    ref.current?.update();
  };

  return (
    <Tooltip
      ref={ref}
      direction={direction}
      eventHandlers={eventHandlers}
      pane="popupPane"
      position={position}
      className={`cluster-tooltip ${tooltipType}`}
      {...props}
    >
      {type === 'summary' && <ClusterSummary data={summaryData} />}
      {type === 'event' && <Box p={2}><EventBreadcrumbPopover data={selectedData} dataLoaded={handleDataLoaded} /></Box>}
    </Tooltip>
  );
};
